import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'

import { BdcPropertyUnitDialogComponent } from './bdc-property-unit-dialog.component'
import { BdcUnitResponse } from '@tokeet-frontend/channel-content'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable()
export class BdcPropertyUnitDialogService {
  constructor(private dialog: DialogService) {}

  open(propertyId: number, propertyTypeId: number, unit?: BdcUnitResponse) {
    const defaultConfig: MatDialogConfig = {
      panelClass: ['drawer-full-60'],
      data: { unit, propertyId, propertyTypeId },
    }

    return this.dialog.openDrawer(BdcPropertyUnitDialogComponent, defaultConfig)
  }
}
